<template>
  <nav class="c-menu__wrapper" :class="isOpened ? 'is-active' : ''" role="navigation" aria-label="main navigation">
    <button
      class="c-menu__cross-button"
      :tabindex="isOpened ? '0' : '-1'"
      v-shortkey="['esc']"
      @shortkey="closeMenu"
      @click="closeMenu"
      :aria-label="`${$t('CLOSE_MENU')}`">
      <close/>
    </button>
    <simplebar class="scrollbox" data-simplebar-auto-hide="false" data-simplebar-force-visible="true">
      <a href="#" class="c-menu__link" :tabindex="isOpened ? '0' : '-1'">
        <ProfileIcon class="c-menu__svg"/>
        <span class="c-menu__title">{{ username }}</span>
      </a>
      <language-menu :menu-opened="isOpened"></language-menu>
      <a
        href="https://www.fagbokforlaget.no/Forlaget/Cookies"
        target="_blank"
        rel="noopener"
        class="c-menu__link"
        :aria-label="`${$t('GO_TO')} ${$t('TERMS_AND_CONDITIONS')} ${$t('PAGE')}`"
        :tabindex="isOpened ? '0' : '-1'">
        <TOCIcon class="c-menu__svg"/>
        <span class="c-menu__title">{{ $t('TERMS_AND_CONDITIONS') }}</span>
      </a>
      <a
        href="https://www.fagbokforlaget.no/d-bok"
        target="_blank"
        rel="noopener"
        class="c-menu__link"
        :aria-label="`${$t('GO_TO')} ${$t('HELP')} ${$t('PAGE')}`"
        :tabindex="isOpened ? '0' : '-1'">
        <HelpIcon class="c-menu__svg"/>
        <span class="c-menu__title">{{ $t('HELP') }}</span>
      </a>
    </simplebar>
    <button class="c-menu__logout" @click="onLogout" :tabindex="isOpened ? '0' : '-1'">
      <LogoutIcon class="c-menu__svg"/>
      <span class="c-menu__title">{{ $t('LOGOUT') }}</span>
    </button>
  </nav>
</template>

<script>
import { mapGetters  } from 'vuex'
import Simplebar from 'simplebar-vue'

import ProfileIcon from '@/assets/svg/ProfileIcon'
import TOCIcon from '@/assets/svg/TOCIcon'
import HelpIcon from '@/assets/svg/HelpIcon'
import LogoutIcon from '@/assets/svg/LogoutIcon'
import LanguageDropdown from './LanguageDropdown';
import Close from '@/assets/svg/Close'
import { mapActions } from 'vuex'

export default {
  name: 'BurgerMenu',

  components: {
    'ProfileIcon': ProfileIcon,
    'TOCIcon': TOCIcon,
    'HelpIcon': HelpIcon,
    'LogoutIcon': LogoutIcon,
    'language-menu': LanguageDropdown,
    'close': Close,
    'simplebar': Simplebar
  },

  computed: {
    ...mapGetters({
      username: 'user/getUserName'
    })
  },

  data() {
    return {
      toggledMenu: Boolean
    }
  },

  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    isOnTablet: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      clearToken: 'user/clearToken'
    }),

    onLogout () {
      this.clearToken()
        .then(() => {
          this.$router.push('/')
        })
    },

    closeMenu() {
      this.toggledMenu = false;
      this.$emit('menu-toggle', this.toggledMenu)
    }
  }
}
</script>

<style lang="scss">
@import '../../node_modules/simplebar/dist/simplebar.min.css';
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

$logout-button-height: 40px;

.c-menu__cross-button {
  @include btnReset();
  position: absolute;
  right: 11px;
  top: 22px;
  width: 32px;
  height: 32px;
  &:hover {
    border-radius: 16px;
    background: $lighter-dark-blue;
    cursor: pointer;
  }
  @include a11yOutline();
  g {
    stroke: $white;
  }
}
.c-menu__wrapper {
  width: 100%;
  background-color: $blue;
  overflow: hidden;
  position: fixed;
  top:0;
  bottom: 0;
  left: -100%;
  z-index: 999;
  padding: 62px 0 0;
  transition: all .5s;
}
.c-menu__wrapper.is-active {
  left: 0;
  padding: 62px 0 0;
  z-index: 99999999999;
}
.c-menu__wrapper + .page-wrap,
.c-menu__wrapper + .page-wrap nav {
  margin: 0;
  transition: all .5s;
}
.c-menu__wrapper.is-active + .page-wrap,
.c-menu__wrapper.is-active + .page-wrap nav {
  margin-left:100%;
  transition: all 1s;
}
.c-menu__wrapper .c-menu__link {
  display: block;
  padding: 20px 40px;
  font-size: 18px;
  line-height: 32px;
  &:hover {
    background-color: $lighter-dark-blue;
  }
  @include a11yOutlineWithOffset();
}
.c-menu__svg {
  vertical-align: middle;
}
.c-menu__title {
  vertical-align: middle;
}
.c-menu__logout {
  @include btnReset();
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  text-align: center;

  background: $logout-bg;

  cursor: pointer;
  @include a11yOutlineWithOffset();

  svg {
    margin-top: 4px;
  }

  .c-menu__title {
    font-size: 14px;
    font-weight: 300;
    line-height: 40px;
  }
  &:hover {
    background: $logout-bg-hover;
  }
}

.scrollbox {
  height: calc(100% - #{$logout-button-height});
}

@media screen and (min-width: 330px) {
  .c-menu__wrapper {
    left: -330px;
    width: 330px;
  }
  .c-menu__wrapper.is-active + .page-wrap,
  .c-menu__wrapper.is-active + .page-wrap nav {
    margin-left: 330px;
  }
}
</style>
